var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99896 14.5292C8.00729 14.5292 6.39062 12.9125 6.39062 10.9208C6.39062 8.92917 8.00729 7.3125 9.99896 7.3125C11.9906 7.3125 13.6073 8.92917 13.6073 10.9208C13.6073 12.9125 11.9906 14.5292 9.99896 14.5292ZM9.99896 8.5625C8.69896 8.5625 7.64062 9.62083 7.64062 10.9208C7.64062 12.2208 8.69896 13.2792 9.99896 13.2792C11.299 13.2792 12.3573 12.2208 12.3573 10.9208C12.3573 9.62083 11.299 8.5625 9.99896 8.5625Z",
    fill: "#B0BECF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99844 18.4396C6.8651 18.4396 3.90677 16.6063 1.87344 13.4229C0.990104 12.0479 0.990104 9.80625 1.87344 8.42292C3.9151 5.23958 6.87344 3.40625 9.99844 3.40625C13.1234 3.40625 16.0818 5.23958 18.1151 8.42292C18.9984 9.79792 18.9984 12.0396 18.1151 13.4229C16.0818 16.6063 13.1234 18.4396 9.99844 18.4396ZM9.99844 4.65625C7.30677 4.65625 4.73177 6.27292 2.93177 9.09792C2.30677 10.0729 2.30677 11.7729 2.93177 12.7479C4.73177 15.5729 7.30677 17.1896 9.99844 17.1896C12.6901 17.1896 15.2651 15.5729 17.0651 12.7479C17.6901 11.7729 17.6901 10.0729 17.0651 9.09792C15.2651 6.27292 12.6901 4.65625 9.99844 4.65625Z",
    fill: "#B0BECF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.b3f61fe6d04a6a38441c31e162bf0be8.svg";
export { ForwardRef as ReactComponent };